import React from "react";
import "./ProgressBar.scss";

const ProgressBar = (props) => {
  
  const { pct, mark=50 } = props;

  return (
    <> 
      <div className='progressbar-holder'>
        <svg id="chart" width="100%" height="100%"><line x1={`${mark}%`} x2={`${mark}%`} y1="5%" y2="100%"></line></svg>

        <div className="progress" style={{ width: `${pct}%`}}  />
      </div>
      
    </>
  );
};

export default ProgressBar;